// extracted by mini-css-extract-plugin
module.exports = {"noData":"EmailsDashboard_noData__Q3jo4","noDataTitle":"EmailsDashboard_noDataTitle__3wrA1","noItemsContainer":"EmailsDashboard_noItemsContainer__2N0QN"};